import { motion } from "framer-motion";
import { Mail, Phone } from "lucide-react";

export default function ContactStrip() {
  return (
    <section id="contact" className="relative overflow-hidden bg-orange-500 py-20 sm:py-28">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -right-8 top-1/2 -translate-y-1/2 select-none font-heading text-[16rem] font-extrabold uppercase leading-none text-[#0B0F17]/10"
      >
        022
      </span>
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-[#0B0F17]/70">
            06 — Talk to Jason
          </p>
          <h2 className="font-heading text-3xl font-extrabold uppercase tracking-tight text-[#0B0F17] sm:text-5xl">
            Straight to
            <br />
            the owner.
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-[#0B0F17]/80 sm:text-lg">
            Jason answers his own phone. Leaking gutter in a storm? Rust creeping across the roof?
            Call now and get it sorted.
          </p>

          <a
            href="tel:0225477534"
            data-testid="contact-strip-jason-phone"
            className="mt-10 block font-heading text-4xl font-extrabold tracking-tight text-[#0B0F17] transition-opacity duration-200 hover:opacity-70 sm:text-6xl"
          >
            022 547 7534
          </a>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="tel:0225477534"
              data-testid="contact-strip-call-btn"
              className="inline-flex items-center gap-3 bg-[#0B0F17] px-8 py-4 font-heading text-sm font-bold uppercase tracking-[0.15em] text-orange-400 transition-colors duration-300 hover:bg-[#131924]"
            >
              <Phone className="h-4 w-4" /> Call Jason now
            </a>
            <a
              href="mailto:jason@totalroofcaretaranaki.co.nz"
              data-testid="contact-strip-email-btn"
              className="inline-flex items-center gap-3 border-2 border-[#0B0F17] px-8 py-4 font-heading text-sm font-bold uppercase tracking-[0.15em] text-[#0B0F17] transition-colors duration-300 hover:bg-[#0B0F17] hover:text-orange-400"
            >
              <Mail className="h-4 w-4" /> Email us
            </a>
          </div>

          <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-[#0B0F17]/60">
            Servicing all of Taranaki · Storm damage prioritised
          </p>
        </motion.div>
      </div>
    </section>
  );
}
